
import moment from 'moment';
import { store } from "../../../source/index";

export const formatDate = (date) => {
    var state = store.getState();
    var OrgSettings = state?.app?.posorganisation_settings;
    let response = moment(date)?.utc(true)?.format(OrgSettings?.date_format);
    return response;
}

export const date_format_change = (date_format) => {
    if (date_format === "d/m/Y") {
        return "DD/MM/YYYY";
    }
    if (date_format === 'Y/m/d') {
        return "YYYY/MM/DD";
    }
    if (date_format === 'm/d/Y') {
        return "MM/DD/YYYY";
    }
    if (date_format === 'm/Y/d') {
        return "MM/YYYY/DD";
    }
    return date_format;
};

const getOrgMomentDateFormat = () => {
    const state = store.getState();
    const orgFormat = state?.app?.posorganisation_settings?.date_format;
    return date_format_change(orgFormat) || "DD/MM/YYYY";
};

/** Parse a date string using organisation date_format; returns timestamp for sorting. */
export const parseDateWithFormat = (dateString) => {
    if (dateString === null || dateString === undefined || dateString === "") {
        return null;
    }

    const trimmed = String(dateString).trim();
    if (!trimmed) return null;

    const parsed = moment(trimmed, getOrgMomentDateFormat(), true);
    if (!parsed.isValid()) return null;

    return parsed.valueOf();
};

export const handleContractDateChange = () => {
    const formattedDate = moment("30/08/2022", date_format_change('d/m/Y'));
    return formattedDate;

}
